import {AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {AIRealtimeService} from "../../service/aiRealtime.service";
import {Subscription} from "rxjs";
import {Howl} from 'howler';
import {MatButtonModule} from "@angular/material/button";
import {TablerIconsModule} from "angular-tabler-icons";

@Component({
  selector: 'app-ai-realtime-audio',
  standalone: true,
  imports: [CommonModule, ButtonModule, MatButtonModule, TablerIconsModule],
  templateUrl: './ai-realtime-audio.component.html',
})
export class AiRealtimeAudioComponent implements AfterViewInit, OnDestroy {
  @ViewChild('remoteAudio', { static: false }) remoteAudioRef?: ElementRef<HTMLAudioElement>;
  @Input() displayControls = false;

  text = 'Luna vous écoute';
  connected = false;
  private connSub?: Subscription

  constructor(private rt: AIRealtimeService){
    console.log('AiRealtimeAudioComponent creation');
    this.connSub = this.rt.connected$.subscribe(v => {
      this.connected = v;
      if (this.connected) {
        new Howl({
          src: ['assets/sound/speechOn.wav'],
        }).play();
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.remoteAudioRef?.nativeElement) {
      this.rt.attachAudioElement(this.remoteAudioRef.nativeElement);
    }
  }

  ngOnDestroy(): void {
    this.rt.attachAudioElement(null);
    this.connSub?.unsubscribe();
  }

  stop() {
    this.rt.disconnect();
  }

}
